import options from './chart-analog.component';

export default {
    selector: 'dtChartAnalog',
    options
};
